import { Routes } from "react-router-dom";
import rootRoute from "./routes/rootRoute";
import { renderRoutes } from "./routes/routes";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { ThemeProvider } from "./providers/ThemeProvider";
import { Toaster } from "./components/Toast";

function App() {
    return (
        <>
            <Provider store={store}>
                <PersistGate
                    loading={null}
                    persistor={persistor}>
                    <ThemeProvider>
                        <Routes>{rootRoute.map((route) => renderRoutes(route))}</Routes>
                        <Toaster />
                    </ThemeProvider>
                </PersistGate>
            </Provider>
        </>
    );
}

export default App;
